import React, { useEffect, useState } from 'react';
import { Switch } from '@headlessui/react';
import { FormField, IFormField } from './FormField';

interface SwitchFieldProps extends IFormField {
  onChange?: (value: boolean) => void;
  isEnabled?: boolean;
  value?: string;
}

export const SwitchField: React.FC<SwitchFieldProps> = props => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (props.isEnabled !== undefined) {
      setEnabled(props.isEnabled);
    }
  }, [props.isEnabled]);

  return (
    <FormField
      {...props}
      render={({ field }) => (
        <Switch
          defaultValue={field.value}
          checked={enabled}
          onChange={setEnabled}
          className="group inline-flex h-6 w-11 items-center rounded-full bg-gray-400 transition data-[checked]:bg-blue-600"
        >
          <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
        </Switch>
      )}
    />
  );
};
